import { get, unionBy } from "lodash";

const getters = {
  device: (state) => state.device,
  canReboot: (state) => (type) =>
    [
      "lpd_v1",
      "lpd_v2",
      "lpd_v3",
      "lpd_v4",
      "always_home_camera",
      "hp_cam_v1",
      "hp_cam_v2",
      "floodlight_v2",
      "floodlight_pro",
      "floodlight_poe_v1",
      "spotlightw_v2",
      "spotlightw_poe_v1",
      "stickup_cam_v4",
      "cocoa_camera",
      "cocoa_doorbell",
      "cocoa_doorbell_v2",
      "cocoa_doorbell_v3",
      "cocoa_floodlight",
      "stickup_cam_elite",
      "jbox_v1",
      "chime_pro",
      "chime_pro_v2",
      "stickup_cam_gourami",
      "stickup_cam_mini",
      "df_doorbell_clownfish",
      "stickup_cam_medusa",
      "stickup_cam_medusa_poe",
      "stickup_cam_longfin",
      "stickup_cam_longfin_poe",
      "stickup_cam_mini_v2",
      "stickup_cam_mini_ptz_v1",
      "intercom_handset_virtual",
    ].find((kind) => type === kind),
  connected: (state) => state.device.connected,
  macId: (state) => state.device.mac_address,
  owner: (state) => state.device.owner,
  type: (state) => state.device.type,
  doorbotId: (state) => state.device.doorbot_id,
  settings: (state) => state.settings,
  AIActiveWarningsEnabled: (state) =>
    state.settings?.nd?.nd_ai_active_warnings_enabled,
  motionSchedules: (state) => state.motionSchedules,
  weekDaysAbbr: (state) => state.weekDaysAbbr,
  events: (state) => state.events,
  lastStatusReport: (state) => state.lastReport || {},
  deviceOptions: (state) => {
    return get(state, "device.profile.product.options", []);
  },
  diagnostic: (state) => {
    return get(state, "device.health_information.status_report", []);
  },
  reports: (state) => state.reports,
  tags: (state) => state.tags,
  notes: (state) => state.notes,
  authorizedUsers: (state) => {
    const mapper = (flag) => {
      return (info) => ({ ...info, owner: flag });
    };
    let owners = get(state, "device.authorized_users.owners", []).map(
      mapper(true)
    );
    let users = get(state, "device.authorized_users.users", []).map(
      mapper(false)
    );
    return unionBy(owners, users, "email");
  },
  firmwareSettings: (state, getters) => {
    return get(state, `device.${getters.type}_firmware_settings`, {});
  },
};

export default getters;
